import React, { Component } from 'react';
import { actions } from 'react-redux-form';
import Menu from './MenuComponent';
import Header from './HeaderComponent';
import Home from './HomeComponent';
import About from './AboutComponent';
import DishDetail from './DishdetailComponent';
//import CommentForm from './DishdetailComponent'
import Contact from './ContactComponent';
import Footer from './FooterComponent';
import { Switch, Route, Redirect,withRouter } from 'react-router-dom';
import {connect} from 'react-redux';
import { addComment, fetchDishes,fetchPromos, fetchLeaders} from '../redux/ActionCreators';
import { TransitionGroup, CSSTransition } from 'react-transition-group';



const mapStateToProps = state => {
  return {
    dishes: state.dishes,
    comments: state.comments,
    promotions: state.promotions,
    leaders: state.leaders
  }
}
const mapDispatchToProps = (dispatch) => ({
    addComment: (dishId, rating, author, comment) => dispatch(addComment(dishId, rating, author, comment)),
   fetchDishes: () =>  {dispatch(fetchDishes())},
	fetchPromos: () => {dispatch(fetchPromos())},
	fetchLeaders: () => {dispatch(fetchLeaders())},
   resetFeedbackForm: () => { dispatch(actions.reset('feedback'))}
	
  
  });
 

   

class Main extends Component {
	
	  componentDidMount() {
    this.props.fetchDishes();
    this.props.fetchPromos();
    this.props.fetchLeaders();
  }
  
	
  render() {
	  const  HomeComponent = () => {
      return(
          <Home  dish={this.props.dishes.dishes.filter((dish) => dish.featured)[0]}
			        dishesLoading={this.props.dishes.isLoading}
                    dishesErrMess={this.props.dishes.errMess}
              promotion={this.props.promotions.promotions.filter((promo) => promo.featured)[0]}
			  promosLoading={this.props.promotions.isLoading}
              promosErrMess={this.props.promotions.errMess}
              leader={this.props.leaders.leaders.filter((leader) => leader.featured)[0]} 
			   leadersLoading={this.props.leaders.isLoading}
                    leadersErrMess={this.props.leaders.errMess}/>
      );
    }
	const  DishWithId = ({match})=>{
		 
		 return(
			 <DishDetail dish={this.props.dishes.dishes.filter((dish) => dish.id === parseInt(match.params.dishId,10))[0]} 
				 isLoading={this.props.dishes.isLoading}
            errMess={this.props.dishes.errMess}
            comments={this.props.comments.filter((comment) => comment.dishId === parseInt(match.params.dishId,10))} 
			 addComment={this.props.addComment}/>
		 )
	 } 
	  
	  
	  
	  
    return (
      <div>
	  <Header/>
			<TransitionGroup>
				 <CSSTransition key={this.props.location.key} classNames="page" timeout={300}>
			<Switch>
				<Route  path="/home" component={HomeComponent}/>
				<Route  exact path='/menu' component={()=> <Menu dishes = {this.props.dishes} /> } />
				<Route  path="/menu/:dishId" component={DishWithId}/>
				<Route  exact path="/contactus" component={()=> <Contact resetFeedbackForm = {this.props.resetFeedbackForm} /> }/>
				<Route  path="/aboutus" component={()=> <About leaders = {this.props.leaders} /> } />
				
				<Redirect to="/home" />
			
			</Switch>
				</CSSTransition>
			</TransitionGroup>
			<Footer/>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Main));
